import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import Toast from './sub_components/toast';
import * as RebateBonusService from '../services/rebateBonusService'

class RebateBonus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            marketTypes: {},
        };
    }

    componentDidMount() {
        this.getRebateBonusList()
    }

    getRebateBonusList(){
        let marketTypes = {}
        let self = this

        RebateBonusService.getRebateBonusList().then( (res) =>{
            if(!!res && res.length > 0){
                marketTypes = res.reduce(
                    (obj, item) => Object.assign(obj, { [item.betttingType]: item }), {}
                );
            }
            self.setState({ marketTypes: marketTypes })
        })
    }

    onUpdateRebateBonus(type){
        let body = this.state.marketTypes[type]

        if(body.amount === null || body.amount === ""){
            body.amount = 0
        }

        RebateBonusService.updateRebateBonus(body).then( (res) => {
            if(!!res && res.isSuccess){
                this.props.notify(`${type} Rebate Bonus Amount Updated Successfully!`, "success")
                this.getRebateBonusList()
            }else {
                this.props.notify(res.exception.message, "error")
            }
        })
    }

    onChange(e, type){
        let marketTypes = this.state.marketTypes

        marketTypes[type]["amount"] = e.target.value

        this.setState({ marketTypes: marketTypes })
    }

   render() {

      return (
         <div className="bethubs">
            <Header history = {this.props.history} />
            <div className="wrapper">
                <div className="container-fluid container-padding-0">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="main-box">
                                <h5 className="text-blue">Rebate Bonus</h5>
                                <div className="row mx-0">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <div className="table-responsive">
                                            <table id="example" className="table font-12 table-bordered table-sm addpadding mt-2 whitespace">
                                                <thead>
                                                <tr>
                                                    <td><span className="font-weight-bold text-white">Market Type</span></td>
                                                    <td><span className="font-weight-bold text-white">Bet Amount</span></td>
                                                    <td><span className="font-weight-bold text-white">Bonus Amount</span></td>
                                                    <td><span className="font-weight-bold text-white">Action</span></td>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {!!this.state.marketTypes && Object.keys(this.state.marketTypes).length > 0 && Object.keys(this.state.marketTypes).map((type, i) => {
                                                    let mkt = this.state.marketTypes[type]
                                                    return (
                                                        <tr>
                                                            <td>
                                                                <span className="font-weight-bold">{type}</span>
                                                            </td>
                                                            <td>
                                                                <span className="">100000</span>
                                                            </td>
                                                            <td>
                                                                <input type="number" value={mkt.amount} onChange={(e) => { this.onChange(e, type) }} className="form-control d-inline" placeholder="" />
                                                            </td>
                                                            <td>
                                                                <button onClick={() => { this.onUpdateRebateBonus(type) }} className="btn btn-blue">Save</button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
               </div>
            </div>
            <Footer />
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(RebateBonus);